import { render, staticRenderFns } from "./BreadcrumbItem.vue?vue&type=template&id=131d44c2"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports